import { gql } from "apollo-boost"

export const updateHumanResources = gql`
  mutation UpdateHumanResources($data: [CreateHumanResourceInput!]!, $rhToDelete: [ID!]) {
    UpdateHumanResource(data: $data, rhToDelete: $rhToDelete)
  }
`
